import { FileUploader, LightMultipartFormData, assert } from 'zf-infra';
import { net } from '../net';
import { ErrorParser } from '../parser';
import type { UploadParams } from 'zf-infra';

export class LightUploader extends FileUploader {

  private readonly parser: ErrorParser;

  constructor() {
    super();
    this.parser = new ErrorParser();
  }

  async upload<T = string>(file: File | Blob, option?: UploadParams): Promise<T> {
    assert(option?.url != null, 'url cannot be empty');

    const data = new LightMultipartFormData(file, undefined).build();
    const result = await net.post<T>({
      url: option.url,
      data,
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    // 如果上传错误为自定义，需要使用处 渲染错误
    if (option?.customError != null) {
      return result;
    }
    this.parser.parseUploadError(result);
    return result;
  }

}
